import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { DacRepository } from '@/store/dac-state/dac-state.repository';
import { Observable, of } from 'rxjs';

interface getDACPreCreateormObjectProps {
  store: DacRepository;
  dynaDocsModelOptions: Observable<SelectOption[]>;
}

export const getDACPreCreateFormObject = ({ store, dynaDocsModelOptions }: getDACPreCreateormObjectProps): DynamicForm => {
  const callForTenderField: DynamicField<TextFieldProps> = {
    label: 'dac.form.ao',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<number>('dacCreateDtoSupport', 'aoRef'),
    },
  };

  const ppmField: DynamicField<TextFieldProps> = {
    label: 'dac.form.ppm',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<number>('dacCreateDtoSupport', 'ppmRef'),
    },
  };

  const milestoneField: DynamicField<TextFieldProps> = {
    label: 'dac.form.milestone',
    variant: FieldVariant.TEXT,
    isDisabled: of(true),
    props: {
      value: store.getNestedObservable<number>('dacCreateDtoSupport', 'milestoneRef'),
    },
  };

  const dynaDocsModelField: DynamicField<SelectFieldProps> = {
    label: 'dac.form.dynaDocsModel',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'dynaDocsModelId'),
    props: {
      value: store.getObservable<SelectOption>('dynaDocsModelIdSelected'),
      onSelectChange: (value: SelectOption) => {
        store.set('dynaDocsModelIdSelected', value);
        store.setNested('dacCreateDto', 'dynaDocsModelId', value?.code || null);
        store.clearError('dynaDocsModelId');
      },
      placeholder: 'dac.form.dynaDocsModel',
      options: dynaDocsModelOptions,
    },
  };

  return {
    title: '',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [{ fields: [callForTenderField] }, { fields: [ppmField] }, { fields: [milestoneField] }, { fields: [dynaDocsModelField] }],
      },
    ],
  };
};
